import { format, isValid } from 'date-fns';

function toValidDate(value) {
  if (value == null || value === '') return null;
  const date = value instanceof Date ? value : new Date(value);
  return isValid(date) ? date : null;
}

export function formatDate(value) {
  const date = toValidDate(value);
  return date ? format(date, 'dd/MM/yyyy') : '';
}

export function formatDateTime(value) {
  const date = toValidDate(value);
  return date ? format(date, 'dd/MM/yyyy HH:mm') : '';
}
